const join = {
    title: "Data Combiner",
    repo: "https://github.com/jafalca/cse487",
    tech: "Python, Hadoop, git",
    details: [ "A Hadoop MapReduce program to analyze and aggregate data using shared data."]
};

const bulletin = {
    title: "UBulletin",
    repo: "https://github.com/cse442-fall-2019-offering/442projects-loopholes",
    tech: "React, JavaScript, HTML, CSS, Figma, npm, git",
    details: [ "A mobile-first web app for campus clubs and organizations to consolidate posters and flyers on a " +
    "single platform. Allowed creation of graphics from scratch and uploads of premade graphics."]
};

const ballot = {
    title: "ShareHolderBallot",
    repo: "https://github.com/BrianBalayon/shareholder-ballot",
    tech: "React, JavaScript, HTML, CSS, npm, git, Solidity, Remix, Ganache, Drizzle",
    details: ["A decentralized app for the Ethereum blockchain as a solution for secure shareholder voting for " +
    "single voting and per-share voting protocols."]
};

const white = {
    title: "Whitespace Detector",
    repo: "https://github.com/BrianBalayon/50white",
    tech: "Python, Tkinter, OpenCV, git",
    details: [ "A desktop application designed to calculate the amount of whitespace a graphic asset contains. " +
    "Supports popular formats, such as pdf, png, and jpg/jpeg."]
};

const web = {
    title: "Personal Website",
    repo: "https://github.com/BrianBalayon/brianbalayon.github.io",
    tech: "React, JavaScript, HTML, CSS, npm, React Bootstrap, git",
    details: ["My personal website hosted on GitHub pages. Currently using React and React Boostrap to deliver a" +
    "pleasing mobile-first experience."]
};


export const projects = [join, ballot, bulletin, white, web];
